(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row--technology"] && !Shopify.designMode) return;
  try {
    (function() {
    const SWIPER_JS  = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

    function initTechSwipers() {
      document.querySelectorAll('.tech-swiper__slider:not([data-swiper-init])').forEach(function(el) {
        el.setAttribute('data-swiper-init', '');
        new Swiper(el, {
          slidesPerView: 2,
          spaceBetween: 12,
          pagination: {
            el: el.closest('.tech-swiper').querySelector('.tech-swiper__pagination'),
            clickable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: 3,
            }
          }
        });
      });
    }

    function loadSwiper(cb) {
      if (window.Swiper) return cb();

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = SWIPER_CSS;
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = SWIPER_JS;
      script.onload = cb;
      document.head.appendChild(script);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { loadSwiper(initTechSwipers); });
    } else {
      loadSwiper(initTechSwipers);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_tab-technology"] && !Shopify.designMode) return;
  try {
    (function() {
    const SWIPER_JS  = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

    function initTechSwipers() {
      document.querySelectorAll('.tech-swiper__slider:not([data-swiper-init])').forEach(function(el) {
        el.setAttribute('data-swiper-init', '');
        new Swiper(el, {
          slidesPerView: 2,
          spaceBetween: 12,
          pagination: {
            el: el.closest('.tech-swiper').querySelector('.tech-swiper__pagination'),
            clickable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: 3,
            }
          }
        });
      });
    }

    function loadSwiper(cb) {
      if (window.Swiper) return cb();

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = SWIPER_CSS;
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = SWIPER_JS;
      script.onload = cb;
      document.head.appendChild(script);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { loadSwiper(initTechSwipers); });
    } else {
      loadSwiper(initTechSwipers);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
